import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // 👈 ⭐ 이 한 줄이 핵심입니다! 디자인 소환!
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);